<template>
  <div class="ybmxm">
    <div class="top-container">
      <h3 style="padding-left: 50px;">流程配置</h3>
      <el-button style="margin-right: 50px;" type="primary" @click="goback">返回</el-button>
    </div>


    <!-- 流程配置 -->
    <div class="approval-process">
      <!-- 发起审批 -->
      <!-- <el-card class="init-card">
              <el-button type="primary" icon="el-icon-top">发起审批</el-button>
            </el-card> -->
      <div class="init-card">
        <el-card class="init-tit">
          发起审批
        </el-card>
      </div>
      <!-- 这是向下的箭头 -->
      <div class="arrow-container">
        <div class="vertical-line"></div>
        <!-- 竖杠 -->
        <div class="arrow-down"></div>
        <!-- 向下的箭头 -->
      </div>
      <!-- 流程配置容器 -->
      <div class="process-container">
        <div class="process-inner">
          <div v-for="(department, index) in processData" :key="index" class="department-panel">
            <h3>{{ department.name }}</h3>
            <div v-show="department.twActivityPeopleConfigVO.length"
              v-for="(node, nodeIndex) in department.twActivityPeopleConfigVO" :key="nodeIndex">
              <el-card shadow="hover" class="node-card">
                <div class="node-content">
                  <span>{{ node.assigneeName }}</span>
                  <span class="role">{{ node.typeName }}</span>
                  <div class="actions">
                    <el-button icon="el-icon-edit" size="small"
                      @click="editNode(department, nodeIndex, node)"></el-button>
                    <el-button icon="el-icon-delete" size="small" type="danger" plain
                      v-if="identityObj.identityTypeCode != '23'"
                      @click="deleteNode(department, nodeIndex, node)"></el-button>
                  </div>
                </div>
              </el-card>
              <!-- 加号图标 -->
              <div class="split-line" v-if="identityObj.identityTypeCode != '23'">
                <i class=" el-icon-circle-plus" @click="addNode(department, nodeIndex, node)"></i>
              </div>
            </div>
            <div v-show="!department.twActivityPeopleConfigVO.length">
              <el-card shadow="hover" class="node-card">
                请设置负责人
              </el-card>
              <!-- 加号图标 -->
              <div class="split-line">
                <i class="el-icon-circle-plus" @click="addNode(department, 0, 0)"></i>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!-- 审批结束 -->
      <!-- <el-card class="end-card">
              <el-button type="primary" icon="el-icon-bottom">完成审批</el-button>
            </el-card> -->
      <!-- 这是向下的箭头 -->
      <div class="arrow-container">
        <div class="vertical-line"></div>
        <!-- 竖杠 -->
        <div class="arrow-down"></div>
        <!-- 向下的箭头 -->
      </div>
      <div class="end-card">
        <el-card class="init-tit">
          审批结束
        </el-card>
      </div>
    </div>
    <!-- 添加流程节点弹窗 -->
    <el-dialog :visible.sync="dialogVisible1" width="70%" append-to-body title="配置">
      <div>
        <table class="tab">
          <tr>
            <td>流程节点名称</td>
            <td>办理人角色</td>
            <td>办理人</td>
          </tr>
          <tr>
            <td>审批节点</td>
            <td>
              <el-input style="width: 200px" v-model="form.name" autocomplete="off"></el-input>
            </td>
            <td>
              <el-select v-model="form.typeName" placeholder="请选择" @change="huazhong">
                <el-option v-for="(item, index) in Datalist" :key="index" :label="item.realName" :value="index">
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBtn">关闭</el-button>
        <el-button type="primary" @click="assigneeConfig()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import {
    //新接口
    selectIsFlexibleProcess,
    saveAssigneeConfig,
    updateAssigneeConfig,
    deleteAssigneeConfig
  } from "@/api/spgl";
  import { selectRoleList } from "@/api/RuralFinance";

  export default {
    data() {
      return {
        tableData: [],
        dialogVisible1: false,
        department: {}, // 当前选中的流程
        departmentIndex: 0,//当前选中流程的下标
        type: 0,//判断是新增还是编辑 0为新增1为编辑
        Datalist: [],//角色列表
        StartList: [],// 开始审批的数据列表
        peopleIndex: 0,//当前选中负责人下标
        nodeId: '',//负责人节点id
        key: '',//流程id
        form: {
          name: "", typeName: ""
        },
        processData: [

        ],
      };
    },
    computed: {
      ...mapGetters(["userInfo", "identityObj"]),
    },
    created() {

      // this.selectRoleList();
    },
    mounted() {
      let key = JSON.parse(this.$route.query.data).row.key
      this.key = key
      this.selectIsFlexibleProcess(key)
      this.selectRoleList()
    },

    methods: {
      // 关闭弹窗
      closeBtn() {
        this.dialogVisible1 = false
        this.form.name = ""
        this.form.typeName = ""
      },

      // 返回
      goback() {
        this.$router.back()
      },
      // 选择负责人
      huazhong(row) {
        this.form.typeName = this.Datalist[row].realName
        this.peopleIndex = row
      },
      // 查询灵活配置的流程图
      async selectIsFlexibleProcess(key) {
        let params = {
          processId: key
        }
        let res = await selectIsFlexibleProcess(params)
        this.processData = res.twActivityGroupConfigVos
        this.StartList = res.workflowConfigItemList
        console.log("流程图", this.processData)
      },

      // 确认修改或新增
      async assigneeConfig() {
        let content = localStorage.getItem("userInfo");
        let deptId = JSON.parse(content).content.deptId;
        let previousNode = this.department.twActivityPeopleConfigVO.length == 0 ? 0 : this.department.twActivityPeopleConfigVO[this.departmentIndex].id;
        if (this.type == 0) {
          //做必传校验
          if (this.form.name && this.form.typeName) {
            //新增
            let params = {
              assignee: this.Datalist[this.peopleIndex].userId,
              assigneeType: this.Datalist[this.peopleIndex].roleId,
              deptId: deptId,
              groupId: this.department.id,
              key: this.StartList[0].nodeKey,
              typeName: this.form.name,
              previousNode: previousNode,
            }

            // console.log(params, '查看params')
            let res = await saveAssigneeConfig(params)
            if (res.code == 0) {
              this.$message.success(res.msg)
              this.selectIsFlexibleProcess(this.key)
              // 关闭弹窗，清空输入框
              this.closeBtn()
            } else {
              this.$message.info(res.msg)
            }
          } else {
            this.$message.info('添加必填项')

          }
        } else {
          //做必传校验
          if (this.form.name && this.form.typeName) {
            //编辑
            let params = {
              assignee: this.Datalist[this.peopleIndex].userId,
              assigneeType: this.Datalist[this.peopleIndex].roleId,
              deptId: deptId,
              id: this.nodeId,
              typeName: this.form.name,
            }
            let res = await updateAssigneeConfig(params)
            if (res.code == 0) {
              this.$message.success(res.msg)
              this.form.name = ""
              this.form.typeName = ""
              this.selectIsFlexibleProcess(this.key)
              // 关闭弹窗，清空输入框
              this.closeBtn()
            } else {
              this.$message.info(res.msg)
            }
          } else {
            this.$message.info('添加必填项')

          }

          // this.department.nodes[this.departmentIndex] = this.form
        }
        // this.dialogVisible1 = false


      },
      // 添加人员
      addNode(department, index, node) {
        this.type = 0
        this.dialogVisible1 = true
        this.departmentIndex = index
        this.department = department

      },
      // 编辑
      editNode(department, index, node) {
        this.peopleIndex = this.Datalist.findIndex(item => item.userId == node.assignee);


        this.type = 1
        this.dialogVisible1 = true
        this.departmentIndex = index
        this.department = department
        this.form.name = node.typeName
        this.form.typeName = node.assigneeName
        this.nodeId = node.id
      },
      // 删除
      deleteNode(department, index, node) {
        console.log(node, '查看删除节点')

        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await deleteAssigneeConfig({
            id: node.id
          })
          if (res.code == 0) {
            this.selectIsFlexibleProcess(this.key)
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: res.code
            });
          }
          // department.nodes.splice(index, 1);

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      // 获取角色列表
      async selectRoleList() {
        let content = localStorage.getItem("userInfo");
        let deptId = JSON.parse(content).content.deptId;
        console.log("deptId", deptId);
        let params = {
          deptId: deptId,
          pnum: "1",
          psize: "100",
        };
        let res = await selectRoleList(params);
        this.Datalist = res.data;
      },
    },
  };
</script>
<style scoped lang="less">
  .top-container {
    display: flex;
    justify-content: space-between;
    align-items: center
  }

  .approval-process {
    text-align: center;
    padding: 20px;
  }

  .init-card,
  .end-card {
    width: 100%;

    .init-tit {
      width: 20%;
      font-size: 20px;
      font-weight: 500;
      border-radius: 15px;
      margin: auto;
    }
  }

  .process-container {
    width: 100%;
    margin-top: 20px;
    /* display: flex; */
    /* flex-wrap: wrap; */
    /* justify-content: space-around; */
    /* 子元素两侧分配相同间距 */
    /* align-items: flex-start; */
    /* 边框和阴影 */
    border: 1px solid #e4e2e2;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* 增加 padding，避免边框和阴影导致内容溢出 */
    padding: 10px;

    user-select: none;
    /* 禁止文本选中 */
  }

  .process-inner {
    width: 100%;
    overflow-x: auto;
    /* 允许水平滚动 */
    white-space: nowrap;
    /* 禁止子元素换行 */


  }

  .process-inner>div {
    display: inline-block;
    /* 子元素行内排列 */
    vertical-align: top;
    /* 顶部对齐 */
    white-space: normal;
    /* 恢复子元素内部文本换行 */
  }

  .department-panel {
    border: 1px dashed #3B82F6;
    width: 400px;
    padding: 5px;
    /* 调整 margin，确保每个部门之间有明显的间距 */
    margin: 10px 10px 5px 5px;
    border-radius: 10px;
    box-sizing: border-box;
    /* 确保 padding 不影响宽度计算 */
    /* 自适应宽度 */
    /* width: calc(33.33% - 15px); */

    /* 确保三列均匀分布 */
    h3 {
      color: #3B82F6;
    }
  }


  .node-card {
    margin-bottom: 10px;
    border-radius: 8px;
  }

  .node-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }

  .role {
    font-size: 0.8em;
    color: #888;
  }

  /* 分割线样式（修改为加号图标） */
  .split-line {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;

    /* 调整 el-icon-plus 图标的样式 */
    i {
      font-size: 20px;
      /* 图标大小 */
      color: #3B82F6;
      /* 图标颜色 */
    }
  }

  .dot {
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #ccc;
    border-radius: 50%;
    position: relative;
    top: 50%;
    margin-left: -5px;
  }

  /* 向下的箭头 */
  .arrow-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* 居中对齐 */
    margin: 20px;
    /* 添加一些外边距 */
  }

  .vertical-line {
    position: relative;
    width: 4px;
    /* 竖杠的宽度 */
    height: 40px;
    /* 竖杠的高度 */
    background-color: #ccc;

    /* 竖杠颜色 */
    .but {
      position: absolute;
      width: 200px;
      /* 竖杠的宽度 */
      height: 40px;
      /* 竖杠的高度 */
      font-size: 20px;
      color: #00a0e9;
      left: 20px;
    }
  }

  .arrow-down {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    /* 左边透明边框 */
    border-right: 10px solid transparent;
    /* 右边透明边框 */
    border-top: 10px solid #ccc;
    /* 上边黑色边框 */
  }

  /* 添加子节点弹窗 */
  .tab {
    width: 100%;
    border: 1px solid #000;
    border-collapse: collapse;
    /* 合并边框 */
    text-align: center;

    td {
      width: 30%;
      height: 50px;
      border: 1px solid #000;
      padding: 0;
      /* 取消内边距 */
      margin: 0;
      /* 取消外边距 */
    }
  }
</style>
